import { DropDownBox, DropDownBoxLayoutStyle, DropDownBoxSearchMode } from '@apply/components';
import { useBrokerAgreementSearch } from '../../../queries/brokerAgreementQueries';

interface BrokerAgreementSearchFieldProps {
    value: number | undefined;
    onChange: (brokerAgreementId: number | undefined) => void;
    disabled: boolean;
    required: boolean;
}

/**
 * Searches B-Client agreements. As in the old BrokerAgreementSelect, a chosen agreement must be removed (see
 * ClearBrokerAgreementButton) before picking another.
 */
export const BrokerAgreementSearchField = ({ value, onChange, disabled, required }: BrokerAgreementSearchFieldProps) => {
    const dataSource = useBrokerAgreementSearch();
    // Disabled, or an agreement is already chosen (it must be cleared first). Read-only as well as disabled, so the box
    // also gets DropDownBox's grey read-only background
    const cannotChange = disabled || !!value;

    return (
        <DropDownBox
            id='borrowerBrokerAgreementId'
            value={value ?? null}
            onChange={(id: number | null) => onChange(id ?? undefined)}
            label='B-Client'
            required={required}
            dataSource={dataSource}
            displayExpr='displayName'
            valueExpr='id'
            placeholder='Search for B-Client by Business Name, Contact, Borrower Entity, Name or Email...'
            searchMode={DropDownBoxSearchMode.Contains}
            disabled={cannotChange}
            readOnly={cannotChange}
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
